import { RouteObject } from "react-router-dom";
import {
  BillingCancelConfirm,
  BillingDetails,
  BillingMailpoints,
  ClientsClientContact,
  DocumentConversionSettingsByType,
  DocumentConversionSettingsRoot,
  DocumentTaxRegistrationNumberDisplayEdit,
  DocumentTaxRegistrationNumberDisplayView,
  DocumentPdfFilenameSettingsEdit,
  DocumentPdfFilenameSettingsView,
  Licensing,
  PortalHome,
  PortalLogin,
  PortalLoginSuccess,
  PortalPersonalInbox,
  PortalClientInbox,
  PortalClientInboxUsersEdit,
  PortalClientInboxUsersView,
  ProfileChangePassword,
  ProfileChangeUsername,
  ProfileDeletionConfirm,
  ProfileEmailSettings,
  ProfileCreate,
  ProfileSetup,
  TeamChangeOwner,
  TeamMemberOverview,
  TeamActiveTeamMembers,
  PartnerIntegrationsRicohTradeAutomation,
  TeamMemberNotification,
  TeamMemberNotificationEdit,
  TeamGroupsAndRolesEdit,
  TeamGroupsAndRolesCreate,
  TeamGroupsAndRolesTeamView,
  TeamMemberEdit,
  StaffCustomTemplateSearch,
  TeamMemberEmployeeRightsCreate,
  ClientsClientSendingSettingsClientInboxEdit,
  PortalClientInboxItem,
  ProfileNotificationEdit,
  ProfileNotification,
  TeamMemberEmployeeRightsEdit,
  TeamMemberGroups,
  TeamRevoked,
  TeamMemberRevoke,
} from "@makeleaps/ui";
import React from "react";

const pageRoute = (path: string, element: React.ReactNode) => ({
  path,
  element,
});

const routes: Array<RouteObject> = [
  pageRoute("/access-control/team/:mid/", <TeamGroupsAndRolesTeamView />),
  pageRoute("/access-control/team/:mid/edit/", <TeamGroupsAndRolesEdit />),
  pageRoute("/access-control/team/create/:kind/", <TeamGroupsAndRolesCreate />),
  pageRoute("/access-control/team/revoked/", <TeamRevoked />),
  pageRoute("/billing/cancel-confirm", <BillingCancelConfirm />),
  pageRoute("/billing/details", <BillingDetails />),
  pageRoute("/billing/mailpoints", <BillingMailpoints />),
  pageRoute(
    "/capybara/document-template/search",
    <StaffCustomTemplateSearch />
  ),
  pageRoute(
    "/home/client/:mid/clientinbox/edit",
    <ClientsClientSendingSettingsClientInboxEdit />
  ),
  pageRoute("/home/client/:mid/contact", <ClientsClientContact />),
  pageRoute("/home/deletion-confirm", <ProfileDeletionConfirm />),
  pageRoute("/home/profile/change-password", <ProfileChangePassword />),
  pageRoute("/home/profile/create", <ProfileCreate />),
  pageRoute("/home/profile/setup", <ProfileSetup />),
  pageRoute("/home/team/", <TeamActiveTeamMembers />),
  pageRoute("/home/team/:mid/revoke/", <TeamMemberRevoke />),
  pageRoute("/home/team/:mid", <TeamMemberOverview />),
  pageRoute("/home/team/:mid/edit", <TeamMemberEdit />),
  pageRoute("/home/team/create", <TeamMemberEmployeeRightsCreate />),
  pageRoute(
    "/integrations/ricoh-trade-automation/",
    <PartnerIntegrationsRicohTradeAutomation />
  ),
  pageRoute("/licensing", <Licensing />), // /licensing is the new route
  pageRoute("/licensing/distribute", <Licensing />), // /licensing/distribute is the old route which should later be deleted after all links are updated
  pageRoute("/notification/", <ProfileNotification />),
  pageRoute("/notification/edit/", <ProfileNotificationEdit />),
  pageRoute("/notification/employee/:mid/", <TeamMemberNotification />),
  pageRoute(
    "/notification/employee/:mid/edit/",
    <TeamMemberNotificationEdit />
  ),
  pageRoute("/portal/:mid/personal-inbox", <PortalPersonalInbox />),
  pageRoute("/portal/:mid/client-inbox", <PortalClientInbox />),
  pageRoute("/portal/:mid/client-inbox/users/", <PortalClientInboxUsersView />),
  pageRoute(
    "/portal/:mid/client-inbox/users/edit/",
    <PortalClientInboxUsersEdit />
  ),
  pageRoute("/portal/:mid/client-inbox/:mid", <PortalClientInboxItem />),
  pageRoute("/portal/home", <PortalHome />),
  pageRoute("/portal/login", <PortalLogin />),
  pageRoute("/portal/login/success/", <PortalLoginSuccess />),
  pageRoute("/profile/change-username", <ProfileChangeUsername />),
  pageRoute("/profile/email-settings", <ProfileEmailSettings />),
  pageRoute("/team/:mid/groups", <TeamMemberGroups />),
  pageRoute("/team/:mid/rights/", <TeamMemberEmployeeRightsEdit />),
  pageRoute("/team/change-owner", <TeamChangeOwner />),
  pageRoute(
    /*
    Note - Unfortunately some URLs in hats look like they point to endpoints nested inside `/settings/`
    So we need to add a `/*` to catch those routes.
    This means we must place the DocumentConversionSettingsRoot route below the DocumentConversionSettingsByType route.
    */
    "/settings/*",
    <DocumentConversionSettingsRoot />
  ),
  pageRoute(
    "/settings/document/conversion/:documentType",
    <DocumentConversionSettingsByType />
  ),
  pageRoute(
    "/settings/document/pdf-filenames/",
    <DocumentPdfFilenameSettingsView />
  ),
  pageRoute(
    "/settings/document/pdf-filenames/edit",
    <DocumentPdfFilenameSettingsEdit />
  ),
  pageRoute(
    "/settings/document/tax-registration-number/",
    <DocumentTaxRegistrationNumberDisplayView />
  ),
  pageRoute(
    "/settings/document/tax-registration-number/edit",
    <DocumentTaxRegistrationNumberDisplayEdit />
  ),
];

export default routes;
